/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { isSpaceTypeWithUniqueActivity } from "../../../../utils/helpers";

const useNewAvailableActivityIds = ({
	dialog, form
}) => {
	const [newAvailableActivityIds, setNewAvailableActivityIds] = useState([]);
	useEffect(() => {
		if (dialog.value)
			setNewAvailableActivityIds(form.availableActivityIds);
	}, [dialog.value]);
	function add(value) {
        setNewAvailableActivityIds(prev => [...prev, value]);
    }
    function remove(value) {
        setNewAvailableActivityIds(prev => prev.filter(activityId => activityId !== value));
    }
	function clear() {
        setNewAvailableActivityIds([]);
    }
	function exists(value) {
        return newAvailableActivityIds.includes(value);
    }
	function toggleAvailableActivity(value) {
        if (exists(value)) {
            remove(value);
			return;
		}
		if (isSpaceTypeWithUniqueActivity(form.spaceTypeId))
			clear();
		add(value);
    }
	function isEmpty() {
		return newAvailableActivityIds.length === 0;
	}
	return {
		toggleAvailableActivity,
		isEmpty,
		exists,
		value: newAvailableActivityIds
	};
}	
	
export default useNewAvailableActivityIds;